/* [GS-0032] Cart drawer ratings, from a name,rating,count CSV in Shopify Files. */
(function () {
  'use strict';

  var STAR_PATH = 'M6,0L7.42,4.58L12,4.58L8.29,7.42L9.71,12L6,9.17L2.29,12L3.71,7.42L0,4.58L4.58,4.58Z';
  var CACHE_PREFIX = 'as-gs-0032:';

  var ratings = null;
  var loading = null;
  var halfStarId = 0;

  function config() {
    var root = document.querySelector('cart-drawer[data-gs-0032-csv]');
    if (!root) return null;

    var csv = root.getAttribute('data-gs-0032-csv');
    if (!csv) return null;

    return {
      csv: csv,
      url: root.getAttribute('data-gs-0032-url') || '',
      label: root.getAttribute('data-gs-0032-label') || '',
      minCount: parseInt(root.getAttribute('data-gs-0032-min-count'), 10) || 0,
      inherit: root.getAttribute('data-gs-0032-inherit') === 'true'
    };
  }

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function splitRow(line, delimiter) {
    var fields = [];
    var field = '';
    var quoted = false;

    for (var i = 0; i < line.length; i++) {
      var char = line[i];

      if (quoted) {
        if (char !== '"') {
          field += char;
        } else if (line[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          quoted = false;
        }
      } else if (char === '"') {
        quoted = true;
      } else if (char === delimiter) {
        fields.push(field);
        field = '';
      } else {
        field += char;
      }
    }

    fields.push(field);
    return fields;
  }

  /* A German Excel export uses semicolons and comma decimals. */
  function detectDelimiter(text) {
    var firstLine = text.split(/\r?\n/)[0] || '';
    return firstLine.split(';').length > firstLine.split(',').length ? ';' : ',';
  }

  function parseCsv(text) {
    var clean = text.replace(/^﻿/, '');
    var delimiter = detectDelimiter(clean);
    var lines = clean.split(/\r?\n/);
    var rows = [];

    for (var i = 0; i < lines.length; i++) {
      if (!lines[i].trim()) continue;

      var fields = splitRow(lines[i], delimiter);
      if (fields.length < 3) continue;

      var name = fields[0].trim();
      var rating = parseFloat(fields[1].trim().replace(',', '.'));
      var count = parseInt(fields[2].trim(), 10);

      if (!name || isNaN(rating) || isNaN(count)) continue;

      rows.push({ key: normalize(name), rating: rating, count: count });
    }

    return rows;
  }

  function load(settings) {
    if (ratings) return Promise.resolve(ratings);
    if (loading) return loading;

    var cacheKey = CACHE_PREFIX + settings.csv;

    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        ratings = JSON.parse(cached);
        return Promise.resolve(ratings);
      }
    } catch (error) {}

    loading = fetch(settings.csv)
      .then(function (response) {
        if (!response.ok) throw new Error('GS-0032: ratings CSV returned ' + response.status);
        return response.text();
      })
      .then(function (text) {
        ratings = parseCsv(text);

        try {
          for (var i = sessionStorage.length - 1; i >= 0; i--) {
            var key = sessionStorage.key(i);
            if (key && key.indexOf(CACHE_PREFIX) === 0 && key !== cacheKey) {
              sessionStorage.removeItem(key);
            }
          }
          sessionStorage.setItem(cacheKey, JSON.stringify(ratings));
        } catch (error) {}

        return ratings;
      })
      .catch(function () {
        ratings = [];
        return ratings;
      });

    return loading;
  }

  function find(title, settings) {
    var key = normalize(title);
    if (!key) return null;

    var i;

    for (i = 0; i < ratings.length; i++) {
      if (ratings[i].key === key) return ratings[i];
    }

    if (!settings.inherit) return null;

    /* Longest prefix wins, so "Nuby Hoop Türkis" takes "Nuby Hoop". */
    var best = null;
    for (i = 0; i < ratings.length; i++) {
      var candidate = ratings[i];
      if (key.indexOf(candidate.key + ' ') !== 0) continue;
      if (!best || candidate.key.length > best.key.length) best = candidate;
    }

    return best;
  }

  function star(type) {
    var open = '<svg viewBox="0 0 12 12" width="12" height="12" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">';

    if (type === 'half') {
      var id = 'as-gs-0032-half-' + ++halfStarId;
      return open +
        '<defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="0">' +
        '<stop offset="50%" class="as-gs-0032-stop-full"/>' +
        '<stop offset="50%" class="as-gs-0032-stop-empty"/>' +
        '</linearGradient></defs>' +
        '<path d="' + STAR_PATH + '" fill="url(#' + id + ')"/></svg>';
    }

    return open + '<path class="as-gs-0032-star-' + type + '" d="' + STAR_PATH + '"/></svg>';
  }

  /* Nearest half, as in the winning variant: 4.75 reads as five full stars. */
  function stars(rating) {
    var rounded = Math.round(rating * 2) / 2;

    return [1, 2, 3, 4, 5].map(function (position) {
      if (rounded >= position) return star('full');
      if (rounded >= position - 0.5) return star('half');
      return star('empty');
    }).join('');
  }

  function formatScore(rating) {
    return String(rating).replace('.', ',');
  }

  function row(match, settings) {
    var score = formatScore(match.rating);
    var label = settings.label
      .replace('{rating}', score)
      .replace('{count}', match.count);

    var tag = settings.url ? 'a' : 'div';
    var attributes = settings.url
      ? ' href="' + settings.url.replace(/"/g, '&quot;') + '" target="_blank" rel="noopener noreferrer"'
      : '';

    /* role="img" because aria-label alone is not announced on a plain div. */
    if (label) {
      attributes += ' aria-label="' + label.replace(/"/g, '&quot;') + '"';
      if (tag === 'div') attributes += ' role="img"';
    }

    var hidden = label ? ' aria-hidden="true"' : '';

    return '<' + tag + ' class="as-gs-0032-row"' + attributes + '>' +
      '<span class="as-gs-0032-stars" aria-hidden="true">' + stars(match.rating) + '</span>' +
      '<span class="as-gs-0032-rating"' + hidden + '>' + score + '</span>' +
      '<span class="as-gs-0032-count"' + hidden + '>(' + match.count + ')</span>' +
      '</' + tag + '>';
  }

  function inject() {
    var settings = config();
    if (!settings) return;

    load(settings).then(function () {
      if (!ratings.length) return;

      var hosts = document.querySelectorAll('[data-gs-0032-title]');

      for (var i = 0; i < hosts.length; i++) {
        var host = hosts[i];
        if (host.querySelector('.as-gs-0032-row')) continue;

        var title = host.querySelector('.as-gs-0027-title');
        if (!title) continue;

        var match = find(host.getAttribute('data-gs-0032-title'), settings);
        if (!match || match.count < settings.minCount) continue;

        title.insertAdjacentHTML('beforebegin', row(match, settings));
      }
    });
  }

  var pending = false;

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      inject();
    });
  }

  /* The drawer re-renders asynchronously after cart events, wiping injected rows. */
  function start() {
    var drawer = document.querySelector('cart-drawer');
    var root = (drawer && drawer.closest('.shopify-section')) || document.body;

    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    inject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
